import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {PlatformPostPreviewProps} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-multiposting.types';
import {
  getStripMediaLayout,
  PreviewMediaFit,
} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-media-wrapper/social-post-content-media-wrapper.types';
import {PreviewAccountHeader} from '../preview-account-header/preview-account-header';
import {PreviewAccountMetaSkeleton} from '../preview-account-header/components/preview-account-meta-skeleton/preview-account-meta-skeleton';
import {PREVIEW_ACCOUNT_META_BAR_AND_SQUARE} from '../preview-account-header/components/preview-account-meta-skeleton/preview-account-meta-skeleton.types';
import {PreviewAccountHeaderLayout} from '../preview-account-header/preview-account-header.types';
import {PreviewClampedCaption} from '../preview-clamped-caption/preview-clamped-caption';
import {PreviewAssetIcon} from '../preview-asset-icon/preview-asset-icon';
import {TWITTER_ACTION_ICON_PATHS} from './twitter-post-preview.types';
import styles from './twitter-post-preview.module.scss';
import {getCaptionWithPlaceholder} from '@Libraries/social-media-params.library';

export function TwitterPostPreview({account, platformMediaType, publishingParams, numberOfPages, renderMedia}: PlatformPostPreviewProps): ReactElement {
  const getCaptionText = (): string => {
    return getCaptionWithPlaceholder(publishingParams, account.id, platformMediaType);
  };

  const getCaption = (): ReactElement => {
    const captionText = getCaptionText();

    return (
      <div className={styles.twitterCaptionHolder}>
        <PreviewClampedCaption captionText={captionText} textClassName={styles.twitterCaptionClamp}>
          <Text className={styles.twitterCaptionText} size={TextSize.XS} val={captionText} />
        </PreviewClampedCaption>
      </div>
    );
  };

  const getMedia = (): ReactElement => {
    return renderMedia({layout: getStripMediaLayout(numberOfPages), fit: PreviewMediaFit.COVER, frameClassName: styles.twitterMediaFrame});
  };

  return (
    <div className={styles.twitterPost}>
      <div className={styles.twitterTextBlock}>
        <PreviewAccountHeader
          account={account}
          identityClassName={styles.twitterIdentity}
          layout={PreviewAccountHeaderLayout.INLINE}
          metaRow={<PreviewAccountMetaSkeleton parts={PREVIEW_ACCOUNT_META_BAR_AND_SQUARE} />}
          trailingAction={null}
        />
        {getCaption()}
      </div>
      {getMedia()}
      <div className={styles.twitterActionBar}>
        {TWITTER_ACTION_ICON_PATHS.map((iconPath: string): ReactElement => {
          return <PreviewAssetIcon iconPath={iconPath} key={iconPath} />;
        })}
      </div>
    </div>
  );
}
